import { createFileRoute, notFound } from '@tanstack/react-router'

import { env } from '@/env'
import { DevModeSettingsPage } from '@/pages/settings/DevModeSettingsPage'

export const Route = createFileRoute('/_authenticated/settings/dev-mode')({
  beforeLoad: () => {
    if (env.VITE_DEPLOY_ENV === 'prod') {
      throw notFound()
    }
  },
  component: DevModeSettingsPage,
})
